import { Component, OnInit, Input} from '@angular/core';

//import { GridOptions, AllModules, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';

import { Subscription } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { ChiefsOrderInstance, chiefsOrderReviewStatus, ChiefsOrderStatus } from '../../../../models/comodel/chiefsorderdetailsmodel.model';
import { ChiefsOrderSearchSpec } from '../../../../models/comodel/chiefs-order-search-spec.model';
import { finalize, filter } from 'rxjs/operators';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { RouterLinkRendererComponent } from '../../../../common/components/ag-grid/router-link-renderer.component';
import { AuthService } from '../../../../services/auth.service';
import { TabComponent } from '../../../../common/components/tabs/tab.component';
import { LetterStatus } from '../../../../letters/letters.model';


@Component({
    selector: 'ext-chiefs-order-status',
    templateUrl: './ext-chiefs-order-status.component.html',
    standalone: false
})
export class ExternalChiefsOrdersStatusComponent implements OnInit {
    @Input() widgetTitle: string;


    columnDateIssued: ColDef = {
        headerName: 'Date Issued',
        headerTooltip: 'Date Issued',
        field: 'issueDate',
        tooltipValueGetter: this.formatterService.formatDate('issueDate'),
        valueGetter: this.formatterService.formatDate('issueDate'),
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        minWidth: 120
    };

    columnChiefsOrderNumber: ColDef = {
        headerName: "Chief's Order #",
        headerTooltip: "Chief's Order #",
        field: "chiefsOrderNumber",
        tooltipField: 'chiefsOrderNumber',
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: {
            openInNewWindow: true,
            textField: "chiefsOrderNumber",
            url: (data: ChiefsOrderInstance) => {
                return `${this.router.parseUrl(this.router.url).root}/admin/chief-orders/co-details/${data.id}`;
            }
        },
        minWidth: 150
    };

    columnDateLastUpdated: ColDef = {
        headerName: 'Date Last Updated',
        headerValueGetter: "",
        headerTooltip: "Date the Order's Status was set", 
        //headerTooltip: 'Date Last Updated',
        field: 'lastUpdatedTime',
        tooltipValueGetter: this.formatterService.formatDate('lastUpdatedTime'),
        valueGetter: this.formatterService.formatDate('lastUpdatedTime'),
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        minWidth: 160
    };

    columnTemplateName: ColDef = {
        headerName: "RICS Chief's Order Name",
        headerTooltip: "RICS Chief's Order Name",
        field: 'reportTemplateName',
        tooltipField: 'reportTemplateName',
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        minWidth: 180
    };

    subscriptions: Subscription = new Subscription();
	issuedGridOptions: GridOptions;
	issuedGridApi?: GridApi;
	appealedGridOptions: GridOptions;
	appealedGridApi?: GridApi;
	vacatedGridOptions: GridOptions;
	vacatedGridApi?: GridApi;
	revokedGridOptions: GridOptions;
	revokedGridApi?: GridApi;
	suspendedGridOptions: GridOptions;
	suspendedGridApi?: GridApi;
	modifiedGridOptions: GridOptions;
	modifiedGridApi?: GridApi;
	terminatedGridOptions: GridOptions;
	terminatedGridApi?: GridApi;

    data: ChiefsOrderInstance[];
    issuedChiefsOrderInstanceData: ChiefsOrderInstance[];
    appealedChiefsOrderInstanceData: ChiefsOrderInstance[];
    vacatedChiefsOrderInstanceData: ChiefsOrderInstance[];
    revokedChiefsOrderInstanceData: ChiefsOrderInstance[];
    suspendedChiefsOrderInstanceData: ChiefsOrderInstance[];
    modifiedChiefsOrderInstanceData: ChiefsOrderInstance[];
    terminatedChiefsOrderInstanceData: ChiefsOrderInstance[];

    public issuedColumns = [this.columnDateIssued, this.columnChiefsOrderNumber, this.columnTemplateName];
    public otherThanIssuedColumns = [this.columnDateLastUpdated, this.columnChiefsOrderNumber, this.columnTemplateName];

    constructor(
        public authService: AuthService,
        public formatterService: GridFormatterService,
        public chiefsOrderService: ChiefsOrderService,
        private router: Router,
    ) { }

    ngOnInit() {

        this.issuedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.issuedColumns, false, true, true, true);
		this.issuedGridOptions.onGridReady = (params) => { this.issuedGridApi = params.api };

        this.appealedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.otherThanIssuedColumns, false, true, true, true);
		this.appealedGridOptions.onGridReady = (params) => { this.appealedGridApi = params.api };

        this.vacatedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.otherThanIssuedColumns, false, true, true, true);
		this.vacatedGridOptions.onGridReady = (params) => { this.vacatedGridApi = params.api };

        this.revokedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.otherThanIssuedColumns, false, true, true, true);
		this.revokedGridOptions.onGridReady = (params) => { this.revokedGridApi = params.api };

        this.suspendedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.otherThanIssuedColumns, false, true, true, true);
		this.suspendedGridOptions.onGridReady = (params) => { this.suspendedGridApi = params.api };

        this.modifiedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.otherThanIssuedColumns, false, true, true, true);
		this.modifiedGridOptions.onGridReady = (params) => { this.modifiedGridApi = params.api };

        this.terminatedGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.otherThanIssuedColumns);
		this.terminatedGridOptions.onGridReady = (params) => { this.terminatedGridApi = params.api };

        this.refreshData();

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    onTabClicked(tab: TabComponent | null) {
        if ((tab == null || tab.title == "Issued") && this.issuedGridApi) {
            setTimeout(() => {
                this.issuedGridApi.sizeColumnsToFit();
            }, 150);
        } if ((tab == null || tab.title == "Appealed") && this.appealedGridApi) {
            setTimeout(() => {
                this.appealedGridApi.sizeColumnsToFit();
            }, 150);
        }
        if ((tab == null || tab.title == "Vacated") && this.vacatedGridApi) {
            setTimeout(() => {
                this.vacatedGridApi.sizeColumnsToFit();
            }, 150);
        }
        if ((tab == null || tab.title == "Revoked") && this.revokedGridApi) {
            setTimeout(() => {
                this.revokedGridApi.sizeColumnsToFit();
            }, 150);
        }
        if ((tab == null || tab.title == "Suspended") && this.suspendedGridApi) {
            setTimeout(() => {
                this.suspendedGridApi.sizeColumnsToFit();
            }, 150);
        }
        if ((tab == null || tab.title == "Modified") && this.modifiedGridApi) {
            setTimeout(() => {
                this.modifiedGridApi.sizeColumnsToFit();
            }, 150);
        }
        if ((tab == null || tab.title == "Terminated") && this.terminatedGridApi) {
            setTimeout(() => {
                this.terminatedGridApi.sizeColumnsToFit();
            }, 150);
        }
    }

    refreshData(): void {
        let orgId = this.authService.User.organizationId;
        const spec = {
            organizationIds: [orgId],
            statuses: [ChiefsOrderStatus.Appealed, ChiefsOrderStatus.Issued, ChiefsOrderStatus.Modified, ChiefsOrderStatus.Revoked, ChiefsOrderStatus.Suspended,
                ChiefsOrderStatus.Terminated, ChiefsOrderStatus.Vacated],
            letterDeliveryStatuses: ["Delivered"]
        } as ChiefsOrderSearchSpec;

        let chiefsOrdersSubscription$ = this.chiefsOrderService.getChiefsOrderInstances(spec).pipe(finalize(() => { this.subscriptions.add(chiefsOrdersSubscription$); })
        ).subscribe(
            //For now filter out vacate or terminate ones as they don't count
            chiefsOrderInstances => {
                this.data = chiefsOrderInstances.filter(a => a.categoryCode != "VAC" && a.categoryCode != "TER").sort((a, b) => a.lastUpdatedTime > b.lastUpdatedTime ? 1 : -1);

                //Now to filter them by status
                this.issuedChiefsOrderInstanceData = this.data.filter(a => a.status == ChiefsOrderStatus.Issued);
                this.appealedChiefsOrderInstanceData = this.data.filter(a => a.status == ChiefsOrderStatus.Appealed);
                this.vacatedChiefsOrderInstanceData = this.data.filter(a => a.status == ChiefsOrderStatus.Vacated);
                this.revokedChiefsOrderInstanceData = this.data.filter(a => a.status == ChiefsOrderStatus.Revoked);
                this.suspendedChiefsOrderInstanceData = this.data.filter(a => a.status == ChiefsOrderStatus.Suspended);
                this.modifiedChiefsOrderInstanceData = this.data.filter(a => a.status == ChiefsOrderStatus.Modified);
                this.terminatedChiefsOrderInstanceData = this.data.filter(a => a.status == ChiefsOrderStatus.Terminated);
                this.onTabClicked(null);
            },
            error => { console.log(error); console.log("ERROR Fetching the Chief's Orders."); }
        );
    }
}

